import { render, staticRenderFns } from "./DataTable-Courses.vue?vue&type=template&id=80733188"
import script from "./DataTable-Courses.vue?vue&type=script&lang=js"
export * from "./DataTable-Courses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports